// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2sBmm","overflowing":"ReadFullNote_overflowing__2QZYc"};